const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const getTabData = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_TAB_DATA_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_TAB_DATA_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default getTabData;